import {HexEdge} from '@colonist/game-mechanic-validators'
import {type PlayerColor, type PortEdgeState, type PortEdgeStates, type TileEdgePortType} from '@colonist/game-states'

export class PortEdge {
    readonly state: PortEdgeState
    readonly hexEdge: HexEdge

    constructor(state: PortEdgeState) {
        this.state = state

        this.hexEdge = new HexEdge(this.state.x, this.state.y, this.state.z)
    }

    get type(): TileEdgePortType {
        return this.state.type
    }

    get owner(): Exclude<PlayerColor, PlayerColor.None> | undefined {
        return this.state.owner
    }
}

export class PortState {
    private readonly _portEdges: PortEdge[]

    private readonly portEdgeStates: PortEdgeStates

    constructor(portEdgeStates: PortEdgeStates) {
        this._portEdges = []

        this.portEdgeStates = portEdgeStates

        this.loadPorts()
    }

    get portEdges(): readonly PortEdge[] {
        return this._portEdges
    }

    getPortEdgeAtLocation(hexEdge: HexEdge): PortEdge | undefined {
        for(const port of this.portEdges) {
            if(port.hexEdge.sameEdge(hexEdge)) return port
        }
        return undefined
    }

    addPortEdge(portEdge: PortEdge) {
        this._portEdges.push(portEdge)
        const index = this._portEdges.length - 1
        this.portEdgeStates[index] = portEdge.state
    }

    private loadPorts() {
        for(const index in this.portEdgeStates) {
            const portEdgeState = this.portEdgeStates[index]
            if(portEdgeState == undefined) continue

            const portEdge = new PortEdge(portEdgeState)
            this._portEdges.push(portEdge)
        }
    }

    isPortOnEdge(hexEdge: HexEdge): boolean {
        for(const portEdge of this.portEdges) {
            if(portEdge.hexEdge.sameEdge(hexEdge)) return true
        }
        return false
    }
}
